import { render, staticRenderFns } from "./webLogo.vue?vue&type=template&id=32d65c22&scoped=true&"
import script from "./webLogo.vue?vue&type=script&lang=js&"
export * from "./webLogo.vue?vue&type=script&lang=js&"
import style0 from "./webLogo.vue?vue&type=style&index=0&id=32d65c22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d65c22",
  null
  
)

export default component.exports